export const howItWorks = {
  hero: {
    badge: "Guía completa",
    title: "¿Cómo funciona DONKEY TRAVEL?",
    subtitle:
      "La guía definitiva para entender cómo intercambiar tu alojamiento y viajar gratis.",
    cta: "Comenzar ahora",
    learnMore: "Ver los pasos",
  },
  stats: {
    properties: "Alojamientos disponibles",
    exchanges: "Intercambios realizados",
    countries: "Países cubiertos",
    satisfaction: "Satisfacción",
  },
  steps: {
    badge: "El proceso",
    title: "Tu intercambio en 7 pasos",
    subtitle:
      "Un recorrido simple y seguro, desde la inscripción hasta tu primer viaje gratis",
    step1: {
      title: "Crea tu perfil (15 min)",
      description:
        'Es el paso más "largo": 15 minutos para crear tu perfil. ¡Un pequeño esfuerzo para años de vacaciones gratis y felicidad!',
      highlight1: "Suscripción requerida",
      highlight2: "Anuncio completo con fotos",
      highlight3: "Verificación de identidad",
      badge: "Inscripción rápida",
    },
    step2: {
      title: "Explora y encuentra tu destino ideal",
      description:
        "Explora nuestro mapa interactivo de Europa y encuentra anfitriones verificados del club. Filtra por destino, fechas, tipo de alojamiento y equipamiento para organizar tu intercambio.",
      highlight1: "Mapa interactivo de Europa con filtros avanzados",
      highlight2: "Búsqueda por destino, fechas y equipamiento",
      highlight3:
        "Miembros anfitriones verificados en los países europeos disponibles",
      badge: "Búsqueda inteligente",
    },
    step3: {
      title: "Propón un intercambio y negocia",
      description:
        "Contacta con el propietario que te interesa y propón un intercambio. Negocia las fechas y la duración en un espíritu amistoso. ¿10 noches por 5? ¡Todo es posible!",
      highlight1: "Mensajería integrada y segura",
      highlight2: "Negociación flexible de las duraciones",
      highlight3: "Perfiles verificados y reseñas consultables",
      badge: "Negociación fácil",
    },
    step4: {
      title: "Confirma las fechas y sincroniza tus calendarios",
      description:
        "Una vez encontrado el acuerdo, confirma las fechas de intercambio. Tus calendarios de Airbnb y DONKEY TRAVEL se sincronizan automáticamente para evitar conflictos de reserva.",
      highlight1: "Sincronización automática con Airbnb",
      highlight2: "Recordatorios y notificaciones antes de la estancia",
      highlight3: "Modificación flexible hasta 48h antes",
      badge: "Calendario sincronizado",
    },
    step5: {
      title: "Contrato amistoso PDF enviado a los dos anfitriones",
      description:
        "DONKEY TRAVEL edita un contrato amistoso en PDF y lo envía a los dos anfitriones. Una vez finalizado el primer intercambio, dispones de 24 meses para realizar el intercambio de vuelta.",
      highlight1:
        "Contrato amistoso PDF enviado automáticamente a los 2 anfitriones",
      highlight2: "Documento resumen de las fechas y condiciones validadas",
      highlight3:
        "24 meses para realizar el intercambio de vuelta tras la primera estancia",
      badge: "Contrato PDF",
    },
    step6: {
      title: "¡Viaja y disfruta de tu estancia gratis!",
      description:
        "¡Es el gran día! Instálate en tu alojamiento de intercambio y disfruta de unas vacaciones auténticas. Después de tu estancia, deja una reseña para ayudar a la comunidad.",
      highlight1: "Acogida personalizada por el propietario",
      highlight2: "Guía local con recomendaciones",
      highlight3: "Sistema de reseñas después de cada intercambio",
      badge: "¡Buen viaje!",
    },
  },
  advantages: {
    badge: "Nuestras ventajas",
    title: "¿Por qué elegir DONKEY TRAVEL?",
    subtitle:
      "Una plataforma pensada para los propietarios de Airbnb que quieren viajar de otra manera",
    items: {
      security: {
        title: "Seguridad máxima",
        description:
          "Todos los miembros son propietarios de Airbnb verificados. Identidad controlada, reseñas consultables y seguro incluido para cada intercambio.",
      },
      savings: {
        title: "Ahorros considerables",
        description:
          "Viaja gratis intercambiando tus noches. Ahorra de media 2 500€ al año en tus gastos de alojamiento.",
      },
      community: {
        title: "Comunidad de confianza",
        description:
          "Únete a nuestra comunidad de viajeros. Comparte tus experiencias, intercambia consejos y crea vínculos duraderos.",
      },
      support: {
        title: "Soporte 7/7",
        description:
          "Nuestro equipo está disponible en cualquier momento para acompañarte. Chat en directo, correo electrónico y teléfono para una asistencia completa.",
      },
      quality: {
        title: "Alojamientos de calidad",
        description:
          "Cada alojamiento es verificado y puntuado por la comunidad. Estándares altos para garantizar estancias excepcionales.",
      },
      global: {
        title: "Red europea",
        description:
          "Accede a anfitriones verificados en los países europeos disponibles del club y organiza tus intercambios con confianza.",
      },
    },
  },
  testimonials: {
    badge: "Testimonios",
    title: "Han probado y aprobado",
    subtitle: "Descubre las experiencias de nuestros miembros en todo el mundo",
    banner: {
      title: "¡Tú también puedes viajar más a menudo!",
      subtitle:
        "Únete a la comunidad de anfitriones que viajan de forma diferente.",
    },
    items: {
      sophie: {
        name: "Sophie",
        location: "París, Francia",
        badge: "2 intercambios",
        text: "Gracias a DONKEY TRAVEL, visité Barcelona, Roma y Ámsterdam sin pagar alojamiento. La comunidad es reactiva y las discusiones de intercambio son sencillas.",
      },
      marc: {
        name: "Marc",
        location: "Marsella, Francia",
        badge: "1 intercambio",
        text: "El proceso es increíblemente sencillo. En 3 días, encontré un intercambio perfecto para mis vacaciones de verano. La sincronización con Airbnb es una gran ventaja.",
      },
      leaTom: {
        name: "Léa y Tom",
        location: "Lyon, Francia",
        badge: "Nuevos miembros",
        text: "Lo que más nos impresionó es la comunidad. Los propietarios son considerados y los intercambios se realizan en un ambiente de total confianza.",
      },
      dupont: {
        name: "Familia Dupont",
        location: "Burdeos, Francia",
        badge: "3 intercambios",
        text: "¡Perfecto para viajar en familia durante las vacaciones escolares!",
      },
      alex: {
        name: "Alex",
        location: "Berlín, Alemania",
        badge: "5 intercambios",
        text: "Una red increíble para el teletrabajo. Intercambio mi loft en Berlín por apartamentos soleados.",
      },
      marie: {
        name: "Marie",
        location: "Toulouse, Francia",
        badge: "4 intercambios",
        text: "¡Se acabaron las restricciones financieras! Me voy de escapada de fin de semana todos los meses.",
      },
      testimonial2: {
        text: "El proceso es muy simple. En 3 días, encontré un intercambio perfecto para mis vacaciones de verano. La sincronización con Airbnb es una verdadera ventaja.",
      },
      testimonial3: {
        text: "Lo que más me sedujo fue la comunidad. Los propietarios son benévolos y los intercambios se hacen en un ambiente de confianza total.",
      },
    },
  },
  faq: {
    title: "Preguntas frecuentes",
    subtitle: "Todo lo que necesitas saber antes de empezar",
    items: {
      q1: {
        question: "¿La inscripción es de pago?",
        answer:
          "Sí. El acceso a DONKEY TRAVEL se realiza mediante una suscripción anual. Oferta de lanzamiento 2026: 25EUR/año en lugar de 50EUR/año.",
      },
      q2: {
        question: "¿Debo ser propietario de Airbnb para inscribirme?",
        answer:
          "Sí, DONKEY TRAVEL está reservado a propietarios que tienen un alojamiento listado en Airbnb. Esto garantiza la calidad y la fiabilidad de cada miembro de la comunidad.",
      },
      q3: {
        question: "¿Cómo están protegidos los intercambios?",
        answer:
          "Cada intercambio está cubierto por nuestro seguro asociado. Además, todos los miembros son verificados (identidad, alojamiento, reseñas Airbnb) y nuestro equipo de soporte está disponible 7/7.",
      },
      q4: {
        question: "¿Puedo intercambiar con alguien en otro país?",
        answer:
          "Sí. Puedes intercambiar con otros anfitriones verificados en los países europeos disponibles según tu suscripción.",
      },
      q5: {
        question: "¿Qué pasa si el intercambio se cancela?",
        answer:
          "Nuestra política de cancelación protege a ambas partes. En caso de cancelación, te ayudamos a encontrar una alternativa.",
      },
      q6: {
        question: "¿Cuánto dura un intercambio de media?",
        answer:
          "La duración es totalmente flexible y se negocia entre los dos propietarios. De media, los intercambios duran entre 5 y 14 noches, pero algunos hacen intercambios de un fin de semana o de un mes entero.",
      },
    },
  },
  cta: {
    title: "¿Listo para viajar gratis?",
    subtitle: "Únete a nuestra comunidad de viajeros.",
    explore: "Explorar los destinos",
    members: "Miembros activos",
    countries: "Países disponibles",
    satisfaction: "De satisfacción",
  },
};
